
export default {
  name: 'Etfs',
  data() {
    return {
      features: this.$t('features'),
    }
  },
}
